export default "__VITE_PUBLIC_ASSET__a92b5a88__"